import { Input } from "antd"
import React, { useState, useEffect, useCallback } from "react"

const formatMoney = (value) => {
    if (!value && value !== 0) return ""

    const [integer, decimal] = value.toString().split(".")
    const formatted = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",")

    return decimal ? `${formatted}.${decimal}` : formatted
}

const parseMoney = (value) => {
    if (value === null || value === undefined) return ""
    return String(value).replace(/,/g, "")
}

const MoneyInput = ({ value, onChange, readOnly, className }) => {

    const [internal, setInternal] = useState(value ?? "")
    const [focused, setFocused] = useState(false)

    useEffect(() => {
        if (!focused) {
            setInternal(value ?? "")
        }
    }, [value, focused])

    const handleChange = useCallback((e) => {
        const raw = parseMoney(e.target.value)

        if (!/^-?\d*\.?\d*$/.test(raw)) return

        setInternal(raw)
        onChange?.(raw)
    }, [onChange])

    const handleFocus = () => {
        setFocused(true)
        setInternal(parseMoney(internal))
    }

    const handleBlur = () => {
        setFocused(false)
        setInternal(formatMoney(internal))
    }

    return (
        <Input
            value={focused ? internal : formatMoney(internal)}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            inputMode="decimal"
            className={className}
            style={{
                textAlign: "right",
                width: "100%"
            }}
            readOnly={readOnly}
        />
    )
}

export default React.memo(MoneyInput)